var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.count != 0
    ? _c(
        "div",
        { staticClass: "level pagination-form" },
        [
          _vm.isLazy
            ? [
                _vm.remainingCount > 0
                  ? _c("div", { staticClass: "w100" }, [
                      _c("div", { staticClass: "d-flex h-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-cancel",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onShowMore.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm.isLoading
                              ? _c(
                                  "span",
                                  { staticClass: "icon" },
                                  [_c("loader", { attrs: { text: " " } })],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("paginate.showMore")) +
                                  " (" +
                                  _vm._s(_vm.remainingCount) +
                                  ") "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _vm.count > _vm.perPage
                      ? [
                          _c("paginate", {
                            attrs: {
                              "page-count": Math.ceil(_vm.count / _vm.perPage),
                              "click-handler": _vm.paginateChange,
                              "next-text": "&#8250;",
                              "prev-text": "&#8249;",
                              "force-page": _vm.currentPage,
                              "container-class": "paginate-class",
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.hidePerPage
                  ? _c("div", { staticClass: "control level-right" }, [
                      _c("div", { staticClass: "level-item" }, [
                        _vm._v(_vm._s(_vm.$t("paginate.perPage"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "select" },
                        [
                          _c(
                            "b-select",
                            {
                              on: { input: _vm.onChangePerPage },
                              model: {
                                value: _vm.perPage,
                                callback: function ($$v) {
                                  _vm.perPage = $$v
                                },
                                expression: "perPage",
                              },
                            },
                            _vm._l(_vm.optionsPerPage, function (perPage) {
                              return _c(
                                "option",
                                { key: perPage, domProps: { value: perPage } },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(perPage) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }